import { render, staticRenderFns } from "./SiteDocumentNewFrGroup.vue?vue&type=template&id=99000b66"
import script from "./SiteDocumentNewFrGroup.vue?vue&type=script&lang=js"
export * from "./SiteDocumentNewFrGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports